// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabsViewNew-module__font-s-10___FH37T {
  font-size: 10px !important;
}

.TabsViewNew-module__font-s-12___HH2hl {
  font-size: 12px !important;
}

.TabsViewNew-module__font-s-13___EVgQF {
  font-size: 13px !important;
}

.TabsViewNew-module__font-s-14___EM8jA {
  font-size: 14px !important;
}

.TabsViewNew-module__font-s-15___G8ntE {
  font-size: 15px !important;
}

.TabsViewNew-module__font-s-16___I5BKZ {
  font-size: 16px !important;
}

.TabsViewNew-module__font-s-18____9vxk {
  font-size: 18px !important;
}

.TabsViewNew-module__font-s-20___vIrwW {
  font-size: 20px !important;
}

.TabsViewNew-module__font-s-22___Hph9m {
  font-size: 22px !important;
}

.TabsViewNew-module__font-s-28___eyLMx {
  font-size: 28px !important;
}

.TabsViewNew-module__font-w-400___Btgdq {
  font-weight: 400 !important;
}

.TabsViewNew-module__font-w-500___KLHdG {
  font-weight: 500 !important;
}

.TabsViewNew-module__font-w-600___yfUrz {
  font-weight: 600 !important;
}

.TabsViewNew-module__font-w-700___v2bkJ {
  font-weight: 700 !important;
}

.TabsViewNew-module__p-5___cwOZg {
  padding: 5px !important;
}

.TabsViewNew-module__p-12___woNCq {
  padding: 12px !important;
}

.TabsViewNew-module__p-16___S6dGu {
  padding: 16px !important;
}

.TabsViewNew-module__p-30___qkM2g {
  padding: 30px !important;
}

.TabsViewNew-module__p-b-0___hV7_j {
  padding-bottom: 0 !important;
}

.TabsViewNew-module__p-b-5___ZVZsd {
  padding-bottom: 5px !important;
}

.TabsViewNew-module__p-b-10___pZ6IB {
  padding-bottom: 10px !important;
}

.TabsViewNew-module__p-b-12___BLRGI {
  padding-bottom: 12px !important;
}

.TabsViewNew-module__p-b-16___HAPrE {
  padding-bottom: 16px !important;
}

.TabsViewNew-module__p-b-18___aGEgQ {
  padding-bottom: 18px !important;
}

.TabsViewNew-module__p-b-20___eeU8P {
  padding-bottom: 20px !important;
}

.TabsViewNew-module__p-b-25___U59aC {
  padding-bottom: 25px !important;
}

.TabsViewNew-module__p-b-30___QslSc {
  padding-bottom: 30px !important;
}

.TabsViewNew-module__p-b-50___eVWSk {
  padding-bottom: 50px !important;
}

.TabsViewNew-module__p-t-0___KIO09 {
  padding-top: 0 !important;
}

.TabsViewNew-module__p-t-12___KjqOI {
  padding-top: 12px !important;
}

.TabsViewNew-module__p-t-16___pBR0q {
  padding-top: 16px !important;
}

.TabsViewNew-module__p-t-18___Iz4FJ {
  padding-top: 18px !important;
}

.TabsViewNew-module__p-t-20___KuJ_w {
  padding-top: 20px !important;
}

.TabsViewNew-module__p-t-30___Hi84g {
  padding-top: 30px !important;
}

.TabsViewNew-module__p-t-40___kkcow {
  padding-top: 40px !important;
}

.TabsViewNew-module__p-t-50___jTgXs {
  padding-top: 50px !important;
}

.TabsViewNew-module__p-l-20___QeBI5 {
  padding-left: 20px !important;
}

.TabsViewNew-module__p-l-30___SnTNn {
  padding-left: 30px !important;
}

.TabsViewNew-module__p-l-40___bFrRs {
  padding-left: 40px !important;
}

.TabsViewNew-module__p-r-16____icYc {
  padding-right: 16px !important;
}

.TabsViewNew-module__p-r-20___n3IwS {
  padding-right: 20px !important;
}

.TabsViewNew-module__p-r-30___sZUqH {
  padding-right: 30px !important;
}

.TabsViewNew-module__p-r-50___yTXqd {
  padding-right: 50px !important;
}

.TabsViewNew-module__p-r-60___yUEZQ {
  padding-right: 60px !important;
}

.TabsViewNew-module__m-b-1___wWiDD {
  margin-bottom: 1px !important;
}

.TabsViewNew-module__m-b-2___nhekV {
  margin-bottom: 2px !important;
}

.TabsViewNew-module__m-b-6___SQYcv {
  margin-bottom: 6px !important;
}

.TabsViewNew-module__m-b-8___cg3A4 {
  margin-bottom: 8px !important;
}

.TabsViewNew-module__m-b-10___an5d8 {
  margin-bottom: 10px !important;
}

.TabsViewNew-module__m-b-14___Yibti {
  margin-bottom: 14px !important;
}

.TabsViewNew-module__m-b-16___kZZ4v {
  margin-bottom: 16px !important;
}

.TabsViewNew-module__m-b-20___gTht4 {
  margin-bottom: 20px !important;
}

.TabsViewNew-module__m-b-22___km5v3 {
  margin-bottom: 22px !important;
}

.TabsViewNew-module__m-b-24___vc9bI {
  margin-bottom: 24px !important;
}

.TabsViewNew-module__m-b-30___qkRHm {
  margin-bottom: 30px !important;
}

.TabsViewNew-module__m-b-32___kzMqZ {
  margin-bottom: 32px !important;
}

.TabsViewNew-module__m-b-40___jTAEC {
  margin-bottom: 40px !important;
}

.TabsViewNew-module__m-t-2___fri4G {
  margin-top: 2px !important;
}

.TabsViewNew-module__m-t-3___s53CT {
  margin-top: 3px !important;
}

.TabsViewNew-module__m-t-4___kBTvn {
  margin-top: 4px !important;
}

.TabsViewNew-module__m-t-5___rX9_K {
  margin-top: 5px !important;
}

.TabsViewNew-module__m-t-8___EttMR {
  margin-top: 8px !important;
}

.TabsViewNew-module__m-t-10___sslIv {
  margin-top: 10px !important;
}

.TabsViewNew-module__m-t-15___TtCZh {
  margin-top: 15px !important;
}

.TabsViewNew-module__m-t-16___fZpnS {
  margin-top: 16px !important;
}

.TabsViewNew-module__m-t-20___LFXw4 {
  margin-top: 20px !important;
}

.TabsViewNew-module__m-t-22___pjiS8 {
  margin-top: 22px !important;
}

.TabsViewNew-module__m-t-30___VMnCu {
  margin-top: 30px !important;
}

.TabsViewNew-module__m-t-32___p8c7r {
  margin-top: 32px !important;
}

.TabsViewNew-module__m-l-auto___VKB1W {
  margin-left: auto !important;
}

.TabsViewNew-module__m-l-4___nBGoN {
  margin-left: 4px !important;
}

.TabsViewNew-module__m-l-5___oakVt {
  margin-left: 5px !important;
}

.TabsViewNew-module__m-l-6___yUBDX {
  margin-left: 6px !important;
}

.TabsViewNew-module__m-l-8___toljo {
  margin-left: 8px !important;
}

.TabsViewNew-module__m-l-10___HFK7q {
  margin-left: 10px !important;
}

.TabsViewNew-module__m-l-16___Qd8YJ {
  margin-left: 16px !important;
}

.TabsViewNew-module__m-l-20___FlSAF {
  margin-left: 20px !important;
}

.TabsViewNew-module__m-l-24___St08y {
  margin-left: 24px !important;
}

.TabsViewNew-module__m-l-30___s2gKC {
  margin-left: 30px !important;
}

.TabsViewNew-module__m-l-35___oqHLt {
  margin-left: 35px !important;
}

.TabsViewNew-module__m-l-40___ROD99 {
  margin-left: 40px !important;
}

.TabsViewNew-module__m-r-8___bTO_w {
  margin-right: 8px !important;
}

.TabsViewNew-module__m-r-10___kVq01 {
  margin-right: 10px !important;
}

.TabsViewNew-module__m-r-16___oCEmQ {
  margin-right: 16px !important;
}

.TabsViewNew-module__m-r-20___kNRlu {
  margin-right: 20px !important;
}

.TabsViewNew-module__m-r-24___hEI1G {
  margin-right: 24px !important;
}

.TabsViewNew-module__m-r-30___wEWf6 {
  margin-right: 30px !important;
}

.TabsViewNew-module__m-r-40___Mtyzd {
  margin-right: 40px !important;
}

.TabsViewNew-module__border-r-3___dW1O5 {
  border-radius: 3px !important;
}

.TabsViewNew-module__border-r-4___OF6Qx {
  border-radius: 4px !important;
}

.TabsViewNew-module__border-r-6___CoEsV {
  border-radius: 6px !important;
}

.TabsViewNew-module__border-r-10___vBvxT {
  border-radius: 10px !important;
}

.TabsViewNew-module__border-r-12___HbNtf {
  border-radius: 12px !important;
}

.TabsViewNew-module__border-r-16___kjYNt {
  border-radius: 16px !important;
}

.TabsViewNew-module__border-r-50___VUJIq {
  border-radius: 50% !important;
}

.TabsViewNew-module__primary-border___zM8cf {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsViewNew-module__primary-border-b___dQJBl {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsViewNew-module__primary-border-t___k4s42 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsViewNew-module__primary-border-l___fHaBg {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsViewNew-module__primary-border-r___WP9iC {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TabsViewNew-module__secondary-border___Nkv4e {
  border: 1px solid #637768;
}

.TabsViewNew-module__secondary-border-b___ASKIR {
  border-bottom: 1px solid #637768;
}

.TabsViewNew-module__secondary-border-t___D8Wgk {
  border-top: 1px solid #637768;
}

.TabsViewNew-module__secondary-border-l___QP0Fr {
  border-left: 1px solid #637768;
}

.TabsViewNew-module__secondary-border-r___h5e6d {
  border-right: 1px solid #637768;
}

.TabsViewNew-module__gap-0___SwCYX {
  gap: 0 !important;
}

.TabsViewNew-module__gap-2___fKh66 {
  gap: 2px !important;
}

.TabsViewNew-module__gap-4___q3Xmn {
  gap: 4px !important;
}

.TabsViewNew-module__gap-5___K_f5y {
  gap: 5px !important;
}

.TabsViewNew-module__gap-6___R8VV3 {
  gap: 6px !important;
}

.TabsViewNew-module__gap-8___Y9QXS {
  gap: 8px !important;
}

.TabsViewNew-module__gap-10___Ei5_P {
  gap: 10px !important;
}

.TabsViewNew-module__gap-12___Q4t_l {
  gap: 12px !important;
}

.TabsViewNew-module__gap-14___VT_Cf {
  gap: 14px !important;
}

.TabsViewNew-module__gap-16____BhoL {
  gap: 16px !important;
}

.TabsViewNew-module__gap-18___enX1C {
  gap: 18px !important;
}

.TabsViewNew-module__gap-20___t5jvZ {
  gap: 20px !important;
}

.TabsViewNew-module__gap-24___iJDDB {
  gap: 24px !important;
}

.TabsViewNew-module__gap-26___QZs7D {
  gap: 26px !important;
}

.TabsViewNew-module__gap-30___q1ind {
  gap: 30px !important;
}

.TabsViewNew-module__gap-32___Lytho {
  gap: 32px !important;
}

.TabsViewNew-module__gap-40___YlQ2f {
  gap: 40px !important;
}

.TabsViewNew-module__gap-50___XuS1K {
  gap: 50px !important;
}

.TabsViewNew-module__flex-1___MGKHa {
  flex: 1;
}

.TabsViewNew-module__flex-none___Qyj5y {
  flex: none !important;
}

.TabsViewNew-module__flex-column___pqRYL {
  display: flex;
  flex-direction: column !important;
}

.TabsViewNew-module__flex-row___O2_AY {
  display: flex;
  flex-direction: row !important;
}

.TabsViewNew-module__vertically-centered___FEYBK {
  display: flex;
  align-items: center !important;
}

.TabsViewNew-module__horizontally-centered___cIVjB {
  display: flex;
  justify-content: center !important;
}

.TabsViewNew-module__horizontally-end___M8OQP {
  display: flex;
  justify-content: end !important;
}

.TabsViewNew-module__vertically-start___uxKz1 {
  display: flex;
  align-items: start !important;
}

.TabsViewNew-module__space-between___jBKzm {
  display: flex;
  justify-content: space-between !important;
}

.TabsViewNew-module__flex-wrap___cGzdV {
  flex-wrap: wrap !important;
}

.TabsViewNew-module__height-100___AjYrZ {
  height: 100%;
}

.TabsViewNew-module__width-50___P0i1K {
  width: 50% !important;
}

.TabsViewNew-module__width-100___sxAlu {
  width: 100%;
}

.TabsViewNew-module__cursor-pointer___gcZBQ {
  cursor: pointer;
}

.TabsViewNew-module__cursor-not-allowed___DByPU {
  cursor: not-allowed !important;
}

.TabsViewNew-module__absolute-centered___Lyq1H {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TabsViewNew-module__absolute____4t8L {
  position: absolute;
}

.TabsViewNew-module__relative___HnEfW {
  position: relative;
}

.TabsViewNew-module__fixed___LPNrV {
  position: fixed;
}

.TabsViewNew-module__visible___H2xOM {
  opacity: 1;
}

.TabsViewNew-module__invisible___bi4zn {
  opacity: 0;
}

.TabsViewNew-module__col-90___DEZYJ {
  width: 90% !important;
}

.TabsViewNew-module__col-auto___O98jr {
  width: auto !important;
}

.TabsViewNew-module__medical-tabs___wMTjP {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TabsViewNew-module__medical-table-new___wspvY {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabsViewNew-module__medical-table-new___wspvY:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabsViewNew-module__medical-table-new___wspvY::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabsViewNew-module__medical-table-new___wspvY::-webkit-scrollbar-track {
  display: none;
}
.TabsViewNew-module__medical-table-new___wspvY.TabsViewNew-module__no-pagination___aAUrp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabsViewNew-module__medical-table-new___wspvY.TabsViewNew-module__no-pagination___aAUrp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabsViewNew-module__medical-table-new___wspvY.TabsViewNew-module__no-pagination___aAUrp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabsViewNew-module__medical-table-new___wspvY.TabsViewNew-module__no-pagination___aAUrp::-webkit-scrollbar-track {
  display: none;
}

.TabsViewNew-module__medical-table-empty___f80bO {
  padding: 14px 40px !important;
}

.TabsViewNew-module__icon-btn___GbaoO {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TabsViewNew-module__search-icon___RefcY {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TabsViewNew-module__disable-select___xMUrg {
  user-select: none;
}

.TabsViewNew-module__break-word___djMxH {
  word-break: break-word;
}

.TabsViewNew-module__popup-clear-btn___S7Xo6 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TabsViewNew-module__scroll-m-b-20___h7Kie {
  scroll-margin-bottom: 20px;
}

.TabsViewNew-module__container___oh6BG {
  height: 44px;
  display: flex;
}
.TabsViewNew-module__container___oh6BG .TabsViewNew-module__tabs___I6SwZ {
  display: flex;
  flex: 1;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/tabs/TabsViewNew/TabsViewNew.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,aAAA;AA8pBF;AA5pBE;EACE,aAAA;EACA,OAAA;EACA,SAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  height: 44px;\n  display: flex;\n\n  .tabs {\n    display: flex;\n    flex: 1;\n    gap: 20px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TabsViewNew-module__font-s-10___FH37T`,
	"fontS12": `TabsViewNew-module__font-s-12___HH2hl`,
	"fontS13": `TabsViewNew-module__font-s-13___EVgQF`,
	"fontS14": `TabsViewNew-module__font-s-14___EM8jA`,
	"fontS15": `TabsViewNew-module__font-s-15___G8ntE`,
	"fontS16": `TabsViewNew-module__font-s-16___I5BKZ`,
	"fontS18": `TabsViewNew-module__font-s-18____9vxk`,
	"fontS20": `TabsViewNew-module__font-s-20___vIrwW`,
	"fontS22": `TabsViewNew-module__font-s-22___Hph9m`,
	"fontS28": `TabsViewNew-module__font-s-28___eyLMx`,
	"fontW400": `TabsViewNew-module__font-w-400___Btgdq`,
	"fontW500": `TabsViewNew-module__font-w-500___KLHdG`,
	"fontW600": `TabsViewNew-module__font-w-600___yfUrz`,
	"fontW700": `TabsViewNew-module__font-w-700___v2bkJ`,
	"p5": `TabsViewNew-module__p-5___cwOZg`,
	"p12": `TabsViewNew-module__p-12___woNCq`,
	"p16": `TabsViewNew-module__p-16___S6dGu`,
	"p30": `TabsViewNew-module__p-30___qkM2g`,
	"pB0": `TabsViewNew-module__p-b-0___hV7_j`,
	"pB5": `TabsViewNew-module__p-b-5___ZVZsd`,
	"pB10": `TabsViewNew-module__p-b-10___pZ6IB`,
	"pB12": `TabsViewNew-module__p-b-12___BLRGI`,
	"pB16": `TabsViewNew-module__p-b-16___HAPrE`,
	"pB18": `TabsViewNew-module__p-b-18___aGEgQ`,
	"pB20": `TabsViewNew-module__p-b-20___eeU8P`,
	"pB25": `TabsViewNew-module__p-b-25___U59aC`,
	"pB30": `TabsViewNew-module__p-b-30___QslSc`,
	"pB50": `TabsViewNew-module__p-b-50___eVWSk`,
	"pT0": `TabsViewNew-module__p-t-0___KIO09`,
	"pT12": `TabsViewNew-module__p-t-12___KjqOI`,
	"pT16": `TabsViewNew-module__p-t-16___pBR0q`,
	"pT18": `TabsViewNew-module__p-t-18___Iz4FJ`,
	"pT20": `TabsViewNew-module__p-t-20___KuJ_w`,
	"pT30": `TabsViewNew-module__p-t-30___Hi84g`,
	"pT40": `TabsViewNew-module__p-t-40___kkcow`,
	"pT50": `TabsViewNew-module__p-t-50___jTgXs`,
	"pL20": `TabsViewNew-module__p-l-20___QeBI5`,
	"pL30": `TabsViewNew-module__p-l-30___SnTNn`,
	"pL40": `TabsViewNew-module__p-l-40___bFrRs`,
	"pR16": `TabsViewNew-module__p-r-16____icYc`,
	"pR20": `TabsViewNew-module__p-r-20___n3IwS`,
	"pR30": `TabsViewNew-module__p-r-30___sZUqH`,
	"pR50": `TabsViewNew-module__p-r-50___yTXqd`,
	"pR60": `TabsViewNew-module__p-r-60___yUEZQ`,
	"mB1": `TabsViewNew-module__m-b-1___wWiDD`,
	"mB2": `TabsViewNew-module__m-b-2___nhekV`,
	"mB6": `TabsViewNew-module__m-b-6___SQYcv`,
	"mB8": `TabsViewNew-module__m-b-8___cg3A4`,
	"mB10": `TabsViewNew-module__m-b-10___an5d8`,
	"mB14": `TabsViewNew-module__m-b-14___Yibti`,
	"mB16": `TabsViewNew-module__m-b-16___kZZ4v`,
	"mB20": `TabsViewNew-module__m-b-20___gTht4`,
	"mB22": `TabsViewNew-module__m-b-22___km5v3`,
	"mB24": `TabsViewNew-module__m-b-24___vc9bI`,
	"mB30": `TabsViewNew-module__m-b-30___qkRHm`,
	"mB32": `TabsViewNew-module__m-b-32___kzMqZ`,
	"mB40": `TabsViewNew-module__m-b-40___jTAEC`,
	"mT2": `TabsViewNew-module__m-t-2___fri4G`,
	"mT3": `TabsViewNew-module__m-t-3___s53CT`,
	"mT4": `TabsViewNew-module__m-t-4___kBTvn`,
	"mT5": `TabsViewNew-module__m-t-5___rX9_K`,
	"mT8": `TabsViewNew-module__m-t-8___EttMR`,
	"mT10": `TabsViewNew-module__m-t-10___sslIv`,
	"mT15": `TabsViewNew-module__m-t-15___TtCZh`,
	"mT16": `TabsViewNew-module__m-t-16___fZpnS`,
	"mT20": `TabsViewNew-module__m-t-20___LFXw4`,
	"mT22": `TabsViewNew-module__m-t-22___pjiS8`,
	"mT30": `TabsViewNew-module__m-t-30___VMnCu`,
	"mT32": `TabsViewNew-module__m-t-32___p8c7r`,
	"mLAuto": `TabsViewNew-module__m-l-auto___VKB1W`,
	"mL4": `TabsViewNew-module__m-l-4___nBGoN`,
	"mL5": `TabsViewNew-module__m-l-5___oakVt`,
	"mL6": `TabsViewNew-module__m-l-6___yUBDX`,
	"mL8": `TabsViewNew-module__m-l-8___toljo`,
	"mL10": `TabsViewNew-module__m-l-10___HFK7q`,
	"mL16": `TabsViewNew-module__m-l-16___Qd8YJ`,
	"mL20": `TabsViewNew-module__m-l-20___FlSAF`,
	"mL24": `TabsViewNew-module__m-l-24___St08y`,
	"mL30": `TabsViewNew-module__m-l-30___s2gKC`,
	"mL35": `TabsViewNew-module__m-l-35___oqHLt`,
	"mL40": `TabsViewNew-module__m-l-40___ROD99`,
	"mR8": `TabsViewNew-module__m-r-8___bTO_w`,
	"mR10": `TabsViewNew-module__m-r-10___kVq01`,
	"mR16": `TabsViewNew-module__m-r-16___oCEmQ`,
	"mR20": `TabsViewNew-module__m-r-20___kNRlu`,
	"mR24": `TabsViewNew-module__m-r-24___hEI1G`,
	"mR30": `TabsViewNew-module__m-r-30___wEWf6`,
	"mR40": `TabsViewNew-module__m-r-40___Mtyzd`,
	"borderR3": `TabsViewNew-module__border-r-3___dW1O5`,
	"borderR4": `TabsViewNew-module__border-r-4___OF6Qx`,
	"borderR6": `TabsViewNew-module__border-r-6___CoEsV`,
	"borderR10": `TabsViewNew-module__border-r-10___vBvxT`,
	"borderR12": `TabsViewNew-module__border-r-12___HbNtf`,
	"borderR16": `TabsViewNew-module__border-r-16___kjYNt`,
	"borderR50": `TabsViewNew-module__border-r-50___VUJIq`,
	"primaryBorder": `TabsViewNew-module__primary-border___zM8cf`,
	"primaryBorderB": `TabsViewNew-module__primary-border-b___dQJBl`,
	"primaryBorderT": `TabsViewNew-module__primary-border-t___k4s42`,
	"primaryBorderL": `TabsViewNew-module__primary-border-l___fHaBg`,
	"primaryBorderR": `TabsViewNew-module__primary-border-r___WP9iC`,
	"secondaryBorder": `TabsViewNew-module__secondary-border___Nkv4e`,
	"secondaryBorderB": `TabsViewNew-module__secondary-border-b___ASKIR`,
	"secondaryBorderT": `TabsViewNew-module__secondary-border-t___D8Wgk`,
	"secondaryBorderL": `TabsViewNew-module__secondary-border-l___QP0Fr`,
	"secondaryBorderR": `TabsViewNew-module__secondary-border-r___h5e6d`,
	"gap0": `TabsViewNew-module__gap-0___SwCYX`,
	"gap2": `TabsViewNew-module__gap-2___fKh66`,
	"gap4": `TabsViewNew-module__gap-4___q3Xmn`,
	"gap5": `TabsViewNew-module__gap-5___K_f5y`,
	"gap6": `TabsViewNew-module__gap-6___R8VV3`,
	"gap8": `TabsViewNew-module__gap-8___Y9QXS`,
	"gap10": `TabsViewNew-module__gap-10___Ei5_P`,
	"gap12": `TabsViewNew-module__gap-12___Q4t_l`,
	"gap14": `TabsViewNew-module__gap-14___VT_Cf`,
	"gap16": `TabsViewNew-module__gap-16____BhoL`,
	"gap18": `TabsViewNew-module__gap-18___enX1C`,
	"gap20": `TabsViewNew-module__gap-20___t5jvZ`,
	"gap24": `TabsViewNew-module__gap-24___iJDDB`,
	"gap26": `TabsViewNew-module__gap-26___QZs7D`,
	"gap30": `TabsViewNew-module__gap-30___q1ind`,
	"gap32": `TabsViewNew-module__gap-32___Lytho`,
	"gap40": `TabsViewNew-module__gap-40___YlQ2f`,
	"gap50": `TabsViewNew-module__gap-50___XuS1K`,
	"flex1": `TabsViewNew-module__flex-1___MGKHa`,
	"flexNone": `TabsViewNew-module__flex-none___Qyj5y`,
	"flexColumn": `TabsViewNew-module__flex-column___pqRYL`,
	"flexRow": `TabsViewNew-module__flex-row___O2_AY`,
	"verticallyCentered": `TabsViewNew-module__vertically-centered___FEYBK`,
	"horizontallyCentered": `TabsViewNew-module__horizontally-centered___cIVjB`,
	"horizontallyEnd": `TabsViewNew-module__horizontally-end___M8OQP`,
	"verticallyStart": `TabsViewNew-module__vertically-start___uxKz1`,
	"spaceBetween": `TabsViewNew-module__space-between___jBKzm`,
	"flexWrap": `TabsViewNew-module__flex-wrap___cGzdV`,
	"height100": `TabsViewNew-module__height-100___AjYrZ`,
	"width50": `TabsViewNew-module__width-50___P0i1K`,
	"width100": `TabsViewNew-module__width-100___sxAlu`,
	"cursorPointer": `TabsViewNew-module__cursor-pointer___gcZBQ`,
	"cursorNotAllowed": `TabsViewNew-module__cursor-not-allowed___DByPU`,
	"absoluteCentered": `TabsViewNew-module__absolute-centered___Lyq1H`,
	"absolute": `TabsViewNew-module__absolute____4t8L`,
	"relative": `TabsViewNew-module__relative___HnEfW`,
	"fixed": `TabsViewNew-module__fixed___LPNrV`,
	"visible": `TabsViewNew-module__visible___H2xOM`,
	"invisible": `TabsViewNew-module__invisible___bi4zn`,
	"col90": `TabsViewNew-module__col-90___DEZYJ`,
	"colAuto": `TabsViewNew-module__col-auto___O98jr`,
	"medicalTabs": `TabsViewNew-module__medical-tabs___wMTjP`,
	"medicalTableNew": `TabsViewNew-module__medical-table-new___wspvY`,
	"noPagination": `TabsViewNew-module__no-pagination___aAUrp`,
	"medicalTableEmpty": `TabsViewNew-module__medical-table-empty___f80bO`,
	"iconBtn": `TabsViewNew-module__icon-btn___GbaoO`,
	"searchIcon": `TabsViewNew-module__search-icon___RefcY`,
	"disableSelect": `TabsViewNew-module__disable-select___xMUrg`,
	"breakWord": `TabsViewNew-module__break-word___djMxH`,
	"popupClearBtn": `TabsViewNew-module__popup-clear-btn___S7Xo6`,
	"scrollMB20": `TabsViewNew-module__scroll-m-b-20___h7Kie`,
	"container": `TabsViewNew-module__container___oh6BG`,
	"tabs": `TabsViewNew-module__tabs___I6SwZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
